import React from "react";
import { Bug, Lightbulb, Sparkles } from "lucide-react";
import { IssueCategory } from "../types";

export interface CategoryBadgeProps {
  category: IssueCategory | string;
  size?: "sm" | "md";
  className?: string;
}

export const CategoryBadge: React.FC<CategoryBadgeProps> = ({
  category,
  size = "sm",
  className = "",
}) => {
  const isBug = category === "bug";
  const isSuggestion =
    category === "feature_request" || category === "suggestion";
  const isImprovement = category === "improvement";

  const sizeClasses =
    size === "md"
      ? "text-xs px-2.5 py-1 gap-1.5"
      : "text-[11px] px-2 py-0.5 gap-1";

  const iconSize = size === "md" ? "w-3.5 h-3.5" : "w-3 h-3";

  if (isBug) {
    return (
      <span
        className={`inline-flex items-center font-bold rounded-full border bg-rose-50 text-rose-700 border-rose-200 shadow-2xs ${sizeClasses} ${className}`}
      >
        <Bug className={`${iconSize} shrink-0 text-rose-600`} />
        <span>Bug</span>
      </span>
    );
  }

  if (isSuggestion) {
    return (
      <span
        className={`inline-flex items-center font-bold rounded-full border bg-amber-50 text-amber-800 border-amber-200 shadow-2xs ${sizeClasses} ${className}`}
      >
        <Lightbulb className={`${iconSize} shrink-0 text-amber-600`} />
        <span>Suggestion</span>
      </span>
    );
  }

  if (isImprovement) {
    return (
      <span
        className={`inline-flex items-center font-bold rounded-full border bg-cyan-50 text-cyan-800 border-cyan-200 shadow-2xs ${sizeClasses} ${className}`}
      >
        <Sparkles className={`${iconSize} shrink-0 text-cyan-600`} />
        <span>Improvement</span>
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center font-medium rounded-full border bg-slate-50 text-slate-700 border-slate-200 ${sizeClasses} ${className}`}
    >
      <Lightbulb className={`${iconSize} shrink-0 text-slate-500`} />
      <span className="capitalize">{category || "General"}</span>
    </span>
  );
};
